'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.notify_list_show', {
        url: '/notify_list/:company_id',
        template: '<oem-notify-list-show></oem-notify-list-show>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/notify_list/show/notify_list_show.routes.js